import React from 'react';

const sourceLabels = {
  sender: 'Expediteur',
  internal_db: 'Analyses precedentes',
  community_reports: 'Signalements',
  whois: 'WHOIS',
  'hunter.io': 'Hunter.io',
  smtp_verify: 'SMTP Verify',
  dmarc_record: 'DMARC',
  dns_txt: 'DNS TXT',
};

const confidenceColor = (c) => {
  if (c >= 80) return 'text-safe';
  if (c >= 50) return 'text-caution';
  return 'text-gray-400';
};

export default function DomainEmailsCard({ data, embedded }) {
  if (!data || !data.checked || data.total_found === 0) return null;

  const content = (
    <>
      {/* Domain info */}
      <div className="flex flex-wrap gap-4 mb-4 text-sm">
        <div className="bg-dark-surface/50 rounded-lg px-3 py-1.5">
          <span className="text-gray-500">Domaine : </span>
          <span className="text-white font-mono">{data.domain}</span>
        </div>
        {data.mx_provider && data.mx_provider !== 'unknown' && (
          <div className="bg-dark-surface/50 rounded-lg px-3 py-1.5">
            <span className="text-gray-500">Fournisseur MX : </span>
            <span className="text-white">{data.mx_provider}</span>
          </div>
        )}
        {data.is_catchall !== null && (
          <div className={`rounded-lg px-3 py-1.5 ${data.is_catchall ? 'bg-caution/10 text-caution' : 'bg-dark-surface/50 text-gray-300'}`}>
            {data.is_catchall ? 'Catch-all (accepte tout)' : 'Pas catch-all'}
          </div>
        )}
        {data.accepts_email === false && (
          <div className="bg-danger/10 text-danger rounded-lg px-3 py-1.5">
            Ne recoit pas d'emails (pas de MX)
          </div>
        )}
      </div>

      {/* Risk indicators */}
      {data.risk_indicators && data.risk_indicators.length > 0 && (
        <div className="mb-4 space-y-1">
          {data.risk_indicators.map((r, i) => (
            <div key={i} className={`text-sm ${r.severity === 'high' ? 'text-danger' : 'text-caution'}`}>
              {r.detail}
            </div>
          ))}
        </div>
      )}

      {/* Email list */}
      <div className="space-y-2 max-h-72 overflow-y-auto">
        {data.emails.map((e, i) => (
          <div key={i} className="flex items-center justify-between py-2 border-b border-dark-border last:border-0">
            <div className="flex items-center gap-3 min-w-0">
              <span className="text-white font-mono text-sm truncate">{e.email}</span>
              {e.first_name && e.last_name && (
                <span className="text-gray-500 text-xs">({e.first_name} {e.last_name})</span>
              )}
            </div>
            <div className="flex items-center gap-2 flex-shrink-0 ml-2">
              <span className={`text-xs font-mono ${confidenceColor(e.confidence)}`}>
                {e.confidence}%
              </span>
              <span className="bg-dark-surface text-gray-400 text-xs px-2 py-0.5 rounded">
                {sourceLabels[e.source] || e.source}
              </span>
            </div>
          </div>
        ))}
      </div>

      {data.sources && data.sources.length > 0 && (
        <p className="text-gray-600 text-xs mt-3">
          Sources : {data.sources.join(', ')}
        </p>
      )}
    </>
  );

  if (embedded) return content;

  return (
    <div className="glass-card p-6">
      <h3 className="text-lg font-semibold text-white mb-4 flex items-center gap-2">
        <svg className="w-5 h-5 text-accent-cyan" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
        </svg>
        Emails associes au domaine ({data.total_found})
      </h3>
      {content}
    </div>
  );
}
